import { Component, OnInit } from '@angular/core';
import { ForgotpasswordService } from './forgotpassword.service';
import { ForgotpasswordquestionsService } from './../forgotpasswordquestions/forgotpasswordquestions.service';
import { HttpParams } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SecureStorageService } from '../secure-storage.service';
import { Modal } from 'bootstrap';
import { error } from 'console';
import { RsaService } from '../common_services/encryptutil.service';

@Component({
    selector: 'app-forgotpassword',
    templateUrl: './forgotpassword.component.html',
    styleUrls: ['./forgotpassword.component.scss'],
    providers: [ForgotpasswordService, ForgotpasswordquestionsService],
    standalone: false
})
export class ForgotpasswordComponent implements OnInit {
     loading = false;

     public model =
          {
               userName: '',
               firstName:'',
               lastName:''
          };
     recoveryType = 'Email';
     errorMessage = '';
     news = [];
     sentEmail = false;
     types: any = [
          'Email',
          'SecurityQuestions'
     ];
     isFiledValid = {};
    fieldValidateMsg = {};
    emailMessage = " ";

     isValidUserName = true;

     constructor(
          private forgotService: ForgotpasswordService,
          private questionService: ForgotpasswordquestionsService,
          private router: Router,
          private secureStorage: SecureStorageService,
          private encryptService: RsaService
     ) {

     }
     ngOnInit() {
          this.resetInputValidations();
          this.getNews();
     }

     radioChangeHandler(event: any) {
          this.recoveryType = event.target.value;
     }

     onInputFocus(event: any) {
          this.hideValidate(event.target.name);
     }

     hideValidate(inputName: string) {
          this.isFiledValid[inputName] = true;
     }
     private resetInputValidations() {
          const fieldNameArr = ['firstName', 'lastName', 'userName'];
          for (const fieldName of fieldNameArr) {
              this.isFiledValid[fieldName] = true;
          }
      }
  
      private checkForEmptyField(fieldNameArr: string[]) {
          for (const fieldName of fieldNameArr) {
              this.isFiledValid[fieldName] = this.model[fieldName] !== '' ? true : false;
          }
      }
  
      private setFieldValidates(fieldNameArr: string[]) {
          for (const fieldName of fieldNameArr) {
              this.isFiledValid[fieldName] = false;
          }
      }
      restrictToAlpha(event: any) {
          const inputValue = event.target.value;
          const numberValue = this.extractAlphaString(inputValue);
  
          event.target.value = numberValue;
      }
  
      extractAlphaString(value: string) {
          let newVal = '';
          for (let i = 0; i < value.length; i++) {
              const s: string = value.charAt(i);
              if (this.isAlpha(s)) {
                  newVal += s;
              }
          }
          return newVal;
      }
      isAlpha(str: string) {
          return /^[a-zA-Z]+$/.test(str);
      }

     onSubmit() {

          if (this.model.firstName === '' || this.model.lastName === '' || this.model.userName === '') {
               this.checkForEmptyField(['firstName', 'lastName', 'userName']);
               return;
           }

          this.loading = true;
          const payload={
               "userName":this.model.userName,
               "firstName":this.model.firstName,
               "lastName":this.model.lastName,
               "recoverType":this.recoveryType
          }
          this.forgotService.forgotLoginPassword(payload).subscribe((response:any)=>{
               if(response && response.type){
                    if(response.type === "URL"){
                         window.open('https://myprofile.antheminc.com');
                         this.loading = false;
                    }
                    else if(response.type === "Email"){
                         this.sentEmail = true;
                         this.emailMessage = response.data;
                         this.loading = false;
                    }
                    else if(response.type == "SecurityQuestion"){
                         this.encryptService.setQuestionResponse(response.data);
                         this.showQuestionsPage(this.model.userName);
                         this.loading = false;
                    }
                    else{
                         this.sentEmail = true;
                         this.emailMessage = response.data;
                         this.loading = false;
                    }
               }
               else{
                    this.errorMessage = response.data;
                    this.openModal('myModal');
                    this.loading = false;
                    return;
               }
          },error=>{
               this.errorMessage = 'If the information you submitted matches our records, we will send the associated link to reset your password to your email address';
               this.openModal('myModal');
               this.loading = false;
               return;
          })        





     }
     showQuestionsPage(userName): void {
          this.questionService.updateUserForQuestions(userName);
          this.router.navigate(['./forgotpasswordquestions', { userName: userName }]);
     }

     showLoginPage(userName): void {
          this.router.navigate(['./login']);
     }
     getNews() {
          this.loading = true;
          this.forgotService.getNews((success: boolean, news: any) => {
               if (success) {
                    this.news = news['providerPortalBroadcast'];
                    this.loading = false;

               } else {
                    this.loading = false;
               }
          });

     }

     openModal(modalId:any){
     const modal = new Modal(document.getElementById(modalId));
     modal.show();

     }
     closeModal(modalId:any){
          const modalElement = document.getElementById(modalId);
          const modal = Modal.getInstance(modalElement);
          if(modal!=null){
               modal.hide();
             }


     }
}
